import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { initialLocale } from './app/prefs';
import { initI18n } from './i18n';
import './ui/tokens.css';
import './ui/base.css';
import './ui/operations.css';

initI18n(initialLocale());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
